<template>
	<div>	
		<v-app-bar
			app
			flat
			:clipped-left="isClippedLeft"
			:clipped-right="isClippedRight"
			v-if="isVisibleHeader"
			v-bind="bindStyle"
			:dense="isDense"
			height="80"
			:prominent="isProminent"
			:hide-on-scroll="isHideOnScroll"
			:shrink-on-scroll="isShrinkOnScroll"
			class="elevation-8 px-0"
		>			
			<div v-if="settings.options.logoTB">
				<v-img v-if="!$vuetify.theme.dark"
					:src="'/static/users/pictures/tb/'+settings.options.logoTB"
					:lazy-src="'/static/users/pictures/tb/'+settings.options.logoTB"
					max-height="70"
					:max-width="$vuetify.breakpoint.xs?'140':'210'"
					class="mr-2"
					contain
					position="left center"
				>
				</v-img>
				<v-img v-else
					:src="'/static/users/pictures/tb/'+settings.options.logoTBW"
					:lazy-src="'/static/users/pictures/tb/'+settings.options.logoTBW"
					max-height="70"
					:max-width="$vuetify.breakpoint.xs?'140':'210'"
					class="mr-2"
					contain
					position="left center"
				>
				</v-img>
			</div>	
	
			<div v-else>
				<div style="font-family:cursive!important" class="text-h4 font-weight-black">{{settings.tempBrand?settings.tempBrand:(settings.brand?settings.brand:'')}}</div>
			</div>

			<div class="mt-5 ml-2 float-right" v-if="settings&&settings.level>100">
				<v-switch class="float-left" :color="settings.options.color" inset v-model="isDarkMod"></v-switch>
				<v-icon class="float-right">{{isDarkMod?'mdi-weather-night':'mdi-weather-sunny'}}</v-icon>
			</div>
			<v-spacer></v-spacer>
			<template v-if="settings&&settings.level>10000">
				<v-btn to="/manage250311">M250311</v-btn>
			</template>
			<v-spacer></v-spacer>
			<template v-if="$vuetify.breakpoint.mdAndUp&&settings&&settings.level>2">
				<template v-if="settings&&settings.modules">
					<template v-for="(m,mi) in settings.modules">
						<template>
							<v-tooltip bottom :key="mi" v-if="settings.level>=m.level&&settings.level<=m.maxLevel">
								<template v-slot:activator="{ on, attrs }">
									<template v-if="m.path=='/stats'">
										<v-btn
											fab
											@click="dialog_pwd=1"
											class="neu-glow mx-3"
											active-class="neu-glow-inset"
											v-bind="attrs" 
											v-on="on"
											:disabled="m.umActive"
										>
												<v-icon :large="!$vuetify.breakpoint.xs" :color="m.iconColor">{{m.icon}}</v-icon>
										</v-btn>
									</template>
									<template v-else>
										<v-btn
											fab
											:to="m.path"
											class="neu-glow mx-3"
											active-class="neu-glow-inset"
											v-bind="attrs" 
											v-on="on"
											:disabled="m.umActive"
											>
											<template v-if="m.path=='/manage_db'">
												<v-badge
													color="success"
													:content="unshown"
													overlap
													left
													offset-x="-4"
													offset-y="-12"    
													:value="unshown>0"
												>
												</v-badge>									
												<v-icon :large="!$vuetify.breakpoint.xs" :color="m.iconColor">{{m.icon}}</v-icon>
												<v-badge
													color="warning"
													:content="unconfirmed"
													overlap 
													offset-x="-6"
													offset-y="-12"    
													:value="unconfirmed>0"
												>
												</v-badge>	
											</template>
											<template v-else>
												<v-icon :large="!$vuetify.breakpoint.xs" :color="m.iconColor">{{m.icon}}</v-icon>
											</template>
										</v-btn>
									</template>
								</template>
								<span v-html="m.title"></span>
							</v-tooltip>
						</template>											
					</template>
				</template>
		
				<template v-if="settings&&settings.level==1000">
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								to="users"
								:class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
								active-class="neu-glow-inset"
								v-bind="attrs" 
								v-on="on"
								>
								<v-icon color="info" :large="!$vuetify.breakpoint.xs">mdi-account-group</v-icon>
							</v-btn>
						</template>
						<span>Clienti</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								to="campaigns"
								:class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
								active-class="neu-glow-inset"
								v-bind="attrs" 
								v-on="on"
								>
								<v-icon color="success" :large="!$vuetify.breakpoint.xs">mdi-mailbox</v-icon>
							</v-btn>
						</template>
						<span>Campagne Marketing</span>
					</v-tooltip>
					<v-tooltip bottom>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								fab
								to="invoiceData"
								:class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
								active-class="neu-glow-inset"
								v-bind="attrs" 
								v-on="on"
								>
								<v-icon color="warning" :large="!$vuetify.breakpoint.xs">mdi-invoice</v-icon>
							</v-btn>
						</template>
						<span>Dati Fatturazione</span>
					</v-tooltip>					
				</template>
						
				<v-tooltip bottom >
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon class="mr-0" v-on="on" v-bind="attrs" >
							<v-avatar 
								:size="$vuetify.breakpoint.xs?40:52"
							>
								<v-img :src="settings.avatar?'/static/users/pictures/avatar/'+settings.avatar:'/static/users/pictures/avatar/unknown.png'" ></v-img>
							</v-avatar>
						</v-btn>
					</template>
					<span>{{settings.username||null}}</span>
				</v-tooltip>
				<v-tooltip bottom>
					<template v-slot:activator="{ on, attrs }">
						<v-btn
							fab
							to="/auth/logout"
							:class="!bindStyle.color ? 'neu-glow ml-3' : 'ml-3'"
							active-class="neu-glow-inset"
							v-bind="attrs" 
							v-on="on"
							>
							<v-icon :color="!bindStyle.color ? settings.options.color : bindStyle.color" :large="!$vuetify.breakpoint.xs">mdi-exit-to-app</v-icon>
						</v-btn>
					</template>
					<span>Logout</span>
				</v-tooltip>								
			</template>
			<template v-if="$vuetify.breakpoint.mdAndUp&&settings&&settings.level<2">
				<v-tooltip bottom >
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon class="mr-0" v-on="on" v-bind="attrs" >
							<v-avatar 
								:size="$vuetify.breakpoint.xs?40:52"
							>
								<v-img :src="settings.options.avatar?'/static/users/pictures/avatar/'+settings.options.avatar+'.png':'/static/users/pictures/avatar/unknown.png'" ></v-img>
							</v-avatar>
						</v-btn>
					</template>
					<span>{{settings.username||null}}</span>
				</v-tooltip>
			</template>			
			<template v-else-if="$vuetify.breakpoint.smAndDown&&settings&&settings.level>2">
				<v-menu
				>
					<template v-slot:activator="{ on, attrs }">
						<v-btn icon class="mr-0" v-on="on" v-bind="attrs" >
							<v-avatar 
								:size="$vuetify.breakpoint.xs?40:52"
							>
								<v-img :src="settings.avatar?'/static/users/pictures/avatar/'+settings.avatar:'/static/users/pictures/avatar/unknown.png'" ></v-img>
							</v-avatar>
						</v-btn>
					</template>

					<v-list class="neu-glow-inset full-height-64ex mt-16">
						<v-list-item
							v-for="(m,mi) in settings.modules"
							:key="mi"
							class="mx-0 px-1"
						>
							<v-tooltip left :key="mi" v-if="settings.level>=m.level&&settings.level<=m.maxLevel">
								<template v-slot:activator="{ on, attrs }">

									<template v-if="m.path=='/stats'">
										<v-btn
											fab
											@click="dialog_pwd=1"
											class="neu-glow mx-3"
											active-class="neu-glow-inset"
											v-bind="attrs" 
											v-on="on"
											:disabled="m.umActive"
										>
												<v-icon :large="!$vuetify.breakpoint.xs" :color="m.iconColor">{{m.icon}}</v-icon>
										</v-btn>
									</template>
									<template v-else>
										<v-btn
											fab
											:to="m.path"
											class="neu-glow mx-3 my-2"
											active-class="neu-glow-inset"
											v-bind="attrs" 
											v-on="on"
											>
											<template v-if="m.path=='/manage_db'">
												<v-badge
													color="success"
													:content="unshown"
													overlap
													left
													offset-x="-4"
													offset-y="-12"    
													:value="unshown>0"
												>
												</v-badge>									
												<v-icon :large="!$vuetify.breakpoint.xs" :color="m.iconColor">{{m.icon}}</v-icon>
												<v-badge
													color="warning"
													:content="unconfirmed"
													overlap 
													offset-x="-6"
													offset-y="-12"    
													:value="unconfirmed>0"
												>
												</v-badge>	
											</template>
											<template v-else>
												<v-icon :large="!$vuetify.breakpoint.xs" :color="m.iconColor">{{m.icon}}</v-icon>
											</template>
										</v-btn>
									</template>
								</template>
								<span v-html="m.title"></span>
							</v-tooltip>
						</v-list-item>
						<v-list-item class="mx-0 px-1">
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										fab
										to="/auth/logout"
										class="neu-glow mx-3 my-2"
										active-class="neu-glow-inset"
										v-bind="attrs" 
										v-on="on"
										>
										<v-icon :large="!$vuetify.breakpoint.xs" :color="!bindStyle.color ? settings.options.color : bindStyle.color">mdi-exit-to-app</v-icon>
									</v-btn>
								</template>
								<span>Logout</span>
							</v-tooltip>
						</v-list-item>
						<v-list-item class="mx-0 px-1">
							<v-tooltip bottom v-if="settings&&settings.level>100&&settings.level<1000">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										fab
										to="/settings/?pageId=services"
										:class="!bindStyle.color ? 'neu-glow mx-3' : 'mx-3'"
										active-class="neu-glow-inset"
										v-bind="attrs" 
										v-on="on"
										>
										<v-icon :color="!bindStyle.color ? settings.options.color : bindStyle.color">mdi-shopping</v-icon>
									</v-btn>
								</template>
								<span>Subscribe</span>
							</v-tooltip>
						</v-list-item>
					</v-list>
				</v-menu>
			</template>
			<div class="mt-5 ml-2 float-right" v-if="settings&&(settings.level<2)">
				<v-switch class="float-left" :color="settings.options.color" inset v-model="isDarkMod"></v-switch>
				<v-icon class="float-right">{{isDarkMod?'mdi-weather-night':'mdi-weather-sunny'}}</v-icon>
			</div>
			<!--
			<template v-if="$vuetify.breakpoint.smAndDown&&settings&&settings.level<2">
				<v-btn icon class="mr-0" v-on="on" v-bind="attrs" >
					<v-avatar 
						:size="$vuetify.breakpoint.xs?40:52"
					>
						<v-img :src="settings.options.avatar?'/static/users/pictures/avatar/'+settings.options.avatar+'.png':'/static/users/pictures/avatar/unknown.png'" ></v-img>
					</v-avatar>
				</v-btn>
			</template>
			-->

			<v-tooltip bottom v-if="settings&&settings.level>100&&settings.level<1000&&$vuetify.breakpoint.mdAndUp">
				<template v-slot:activator="{ on, attrs }">
					<v-btn
						fab
						to="/settings/?pageId=services"
						:class="!bindStyle.color ? 'neu-glow mx-3' : 'mx-3'"
						active-class="neu-glow-inset"
						v-bind="attrs" 
						v-on="on"
						>
						<v-icon :color="!bindStyle.color ? settings.options.color : bindStyle.color">mdi-shopping</v-icon>
					</v-btn>
				</template>
				<span>Subscribe</span>
			</v-tooltip>			
		</v-app-bar>
		<v-dialog max-width="400" persistent v-model="dialog_pwd">
			<v-card class="pb-4">
				<v-card-title class="text-h5 mb-3">
				Inserisci Password
				<v-spacer></v-spacer>
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="checkPwd()">
						<v-icon color="success">mdi-check</v-icon>
					</v-btn>
					</template>
					<span>Procedi</span>
				</v-tooltip>   
				<v-tooltip top>
					<template v-slot:activator="{ on, attrs }">
					<v-btn v-bind="attrs" v-on="on" icon fab small class="neu-glow mr-2" @click="dialog_pwd=false">
						<v-icon color="info">mdi-close</v-icon>
					</v-btn>
					</template>
					<span>Esci</span>
				</v-tooltip>                
				</v-card-title>
				<v-divider></v-divider>
				<v-row class="mx-5 mt-2">
					<v-col md="12" cols="12">
						<v-text-field
							label="Password"
							outlined
							autocomplete="off"
							color="info"
							prepend-inner-icon="mdi-lock"
							v-model="statsPWD"
							counter="10"
							hint="Password per accesso KPI"
						>
						</v-text-field>  
					</v-col>
				</v-row>
			</v-card> 
		</v-dialog>  		
	</div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
props:	{
		handleSettingsDrawer: Function,
	},
data() {
	return {
		wIW:window.innerWidth,
		TBM:null,
		unshown:null,
		unconfirmed:null,
		dialog_pwd:null,
		realStatsPWD:'123qw',
		statsPWD:null
	};
},
created(){
	//console.log(286,this.settings);
    if (this.settings&&this.settings.level>20)
	{
		this.getData()
		this.pollData()		
	}
    //console.log(392,this.settings);
},
computed: {
	...mapGetters("scheme", ["dark", "semidark", "header", "footer", "rtl"]),
	...mapGetters(["settings","other_settings","formattedTimeframe"]),
	...mapGetters("navigations", [
		"isVisibleHeader",
		"isSidenavPostionRight",
		"isClippedOver",
		"isMinSideNav",
		"isDense",
		"isProminent",
		"isHideOnScroll",
		"isShrinkOnScroll",
		"isFloating"
		]),
	isDarkMod: {
		get()
		{
			//console.log(163,this.dark);
			return this.dark;
		},
		set(value)
		{
			//console.log168,(this.dark);
			this.$vuetify.theme.dark = value;
			this.$store.dispatch("scheme/setDarkTheme", value);
			localStorage.setItem('dark',value);
		},
	},
	activeItemStyle: (state) => state.activeMenuStyle,

	isClippedRight() {
		return this.isClippedOver && this.isSidenavPostionRight;
	},
	isClippedLeft() {
		return this.isClippedOver && !this.isSidenavPostionRight;
	},
	bindStyle() {
		const { color, dark, classes } = this.header;
		return {
			class:
			{
				"vuse-header": true,
				"with-radius": true,
				[classes]: true,
				"mx-1": this.isFloating && !this.isClippedOver,
				"mx-2": this.$vuetify.breakpoint.mdAndUp
			},
			dark,
			color,
		};
	},
},
watch:{
	settings(newValue,oldValue)
	{
		console.log(422,newValue,oldValue);
		//console.log(423,this.settings)
	}
},
methods: {
	checkPwd()
	{
		console.log(467,this.statsPWD,this.realStatsPWD,this.settings.options.chartsPassword)
		//if (this.statsPWD==this.realStatsPWD)
		if (this.statsPWD==this.settings.options.chartsPassword)
		{
			console.log(470)
			this.statsPWD=null;
			this.dialog_pwd=false;
			this.$router.push('/stats').catch(() => {});
		}
	},
	pollData () {
		//var delay=localStorage.getItem('dev')?500000000000:parseInt(this.settings.options.refreshRate)*1000;
		var delay=localStorage.getItem('dev')?500000000000:this.settings.options.refreshRate?parseInt(this.settings.options.refreshRate)*1000:5000000000;
		this.polling = setInterval(() => {
		console.log(476,'polldata',this.showManualAssignMap,this.showiManagerMa)
		if(!this.showManualAssignMap&&!this.showiManagerMap)
		{
			this.getData()
		}
		}, delay)
    },
    async getData()
    {
		try{
			const payload=JSON.stringify({"date": this.date,"action":"manage_toolbarBadges_get","jwt":0});
			const res = await this.$http.post('/manage/manage.php', payload );
			console.log(435,res);
			switch (res.data.errorid)
			{
				case '0':
					console.log(439,'OK')
					var p=res.data.payloads;
					//sessionStorage.setItem('jwt', res.data.jwt);
					//this.TBM=res.data.payloads.TBM.cnt;
					this.unshown=p.unshown.cnt;
					this.unconfirmed=p.unconfirmed.cnt;
					console.log(442,p.unshown.cnt,p.unconfirmed.cnt);
					console.log(443,this.unshown,this.unconfirmed)
					//this.unshown=3;
					//this.unconfirmed=7;
					//this.$store.dispatch("setMessagesCount",res.data.messagesCount);
				break;

				case '0006':
					this.$router.push('/auth/login').catch(() => {});
				break;
			}
			this.loading= false;
		} catch(e)
		{
			this.loading= false;
		}
    },	
	async getData2()
    {
		try{
			const payload=JSON.stringify({"date": this.date,"action":"getMessagesCount"});
			const res = await this.$http.post('/messages/messages.php', payload );
			//console.log(371,res);
			switch (res.data.errorid)
			{
			case '0':
				sessionStorage.setItem('jwt', res.data.jwt);
				this.messagesCount=res.data.messagesCount;
				this.$store.dispatch("setMessagesCount",res.data.messagesCount);
			break;

			case '0006':
				this.$router.push('/auth/login').catch(() => {});
			break;
			}
			this.loading= false;
		} catch(e)
		{
			this.loading= false;
		}
    },	
	toggleMiniVariant() {
		this.$store.dispatch("navigations/setMiniVariant");
	},
	handleSidenavDrawer() {
		this.$store.dispatch("navigations/setSidenavVisibility");
	},
	handleInternationalization(value,rtl) {
		this.$store.dispatch("setLocale", value);
		//this.$vuetify.rtl = rtl;
		this.$store.dispatch("scheme/setRtl", rtl);
		this.$store.dispatch("navigations/setSidenavPositionRight", rtl);
	},
	handleCurrency(value){
		this.$store.dispatch("setCurrency", value);
	},
	bossPage(){
		sessionStorage.setItem('jwt',sessionStorage.getItem('jwt_b'));
		localStorage.setItem('settings',localStorage.getItem('settings_b'));
		this.$router.push('/boss/users').catch(() => {});
	}
},
  beforeDestroy () {
    clearInterval(this.polling)
  },
};
</script>
<style>
	.v-btn__content{
		text-align:center!important;
	}
</style>
